import { useMutation } from '@tanstack/react-query';

import type {
  FormPayloadSchema,
  FinanceValidationError,
} from '../schema/carFinance.schema';
import { carFinanceApi } from '../../../../api/carFinanceApi';
import { handleFinanceValidationError } from './handleFinanceValidationError';
import { PAGE } from '../../../../helpers/pages';

type UseSubmitFinanceFormProps = {
  onValidationError: (error: FinanceValidationError) => void;
  onSuccess: () => void;
};

const submitFinanceForm = async (payload: FormPayloadSchema) => {
  const { data } = await carFinanceApi.submit(payload);
  return data;
};

export const useSubmitFinanceForm = (props: UseSubmitFinanceFormProps) => {
  const { onValidationError, onSuccess } = props;
  return useMutation({
    mutationKey: ['submitFinanceForm'],
    mutationFn: (options: FormPayloadSchema) => submitFinanceForm(options),
    onError: (error) =>
      handleFinanceValidationError(
        error,
        onValidationError,
        'Car finance form validation error field mismatch',
      ),
    onSuccess,
    meta: { tags: [PAGE.CAR_FINANCE] },
  });
};
